<template>
  <ul class="list-group p-0 sub-menu" :class="[variant, { sticky: isSticky }]">
    <template v-for="(item, index) in items">
      <li
        :key="`sub-menu-item-${index}`"
        class="list-group__item list-group-item"
        :class="{
          disabled: item.disabled,
          active: item.active,
          subactive: item.subactive,
        }"
        :disabled="item.disabled"
      >
        <slot v-bind="{ item }" />
      </li>
      <li
        v-if="isHorizontalArrow || items.length - 1 !== index"
        :key="`sub-menu-item-expander-${index}`"
        class="list-group-item list-group__item-expander"
      />
    </template>
  </ul>
</template>

<script>
// TODO - TH-7092 change slot markup
// https://router.vuejs.org/api/#applying-active-class-to-outer-element
const VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  HORIZONTAL_ARROW = 'horizontal-arrow';

export default {
  name: 'SubMenu',
  props: {
    items: {
      type: Array,
      required: true,
    },
    isSticky: Boolean,
    variant: {
      type: String,
      default: 'vertical',
      validator: s => [VERTICAL, HORIZONTAL, HORIZONTAL_ARROW].includes(s),
    },
  },
  computed: {
    isHorizontalArrow() {
      return this.variant === HORIZONTAL_ARROW;
    },
  },
};
</script>
<style lang="scss">
.sub-menu {
  --bg-color: inherit;
  .list-group__item,
  .list-group__item-expander {
    border: 0;
    padding: 0;
    background: transparent;
  }
  .list-group__item {
    position: relative;
    min-width: 150px;
    &.disabled {
      pointer-events: none;
      color: $ph-secondary-text;
      cursor: not-allowed;
    }

    > a {
      background: $new-bg-page-faded;
      color: $ph-secondary-text;
      font-weight: bold;
      font-size: $ph-caption-bold-font-size;
      text-decoration: none;
      transition: color 0.3s ease-in;
      &.router-link-active,
      &.router-link-alias-active,
      &.router-link-exact-active {
        color: $ph-primary-text;
        &:before {
          background: $new-bg-primary !important;
        }
      }
    }
  }
  &.vertical,
  &.horizontal {
    .list-group__item {
      border-radius: $ph-medium-radius;
      overflow: hidden;
      > a {
        display: block;
        padding: $ph-medium-space;
        &:before {
          content: '';
          position: absolute;
          height: 5px;
          bottom: 0;
          left: 0;
          right: 0;
          background: $new-bg-page-faded;
        }
      }
    }
    .list-group__item-expander {
      flex: 0 0 $ph-medium-space;
    }
  }

  &.horizontal,
  &.horizontal-arrow {
    flex-direction: row;
    .list-group__item > a {
      text-align: center;
    }
  }
  &.horizontal-arrow {
    justify-content: space-between;
    padding-left: 0.575rem !important;
    padding-right: 0.575rem !important;
    // overflow: hidden;
    .list-group__item {
      flex-grow: 1;
      flex-basis: 0;
      > a {
        height: 60px;
        padding-top: $ph-small-space;
        padding-bottom: $ph-small-space;
        @include auto-rtl(
          (
            padding-right: 50%,
            padding-left: $ph-large-space,
          )
        );
        border-radius: $ph-small-radius;
        line-height: 1.2;
      }
      &.subactive > a {
        color: $ph-primary-text;
      }
      &.active {
        > a {
          color: $ph-primary-text;
          background: $ph-green;
        }
        + li:after {
          background: $ph-green;
        }
      }
    }
    .list-group__item-expander {
      flex: 0 0 0.25rem;
      z-index: 5;
      &:after {
        content: '';
        position: absolute;
        width: 3.2rem;
        height: 3.2rem;
        top: 50%;
        /*
        math:
        a = 3.2 * 16 = 51.2;
        b = 2(a**2) ** 0.5 = 72.41;
        c = b/2 * scaleX = 15.2;
        e = 4 (expanderWidth)
        left = -(c + e * 2)
        */
        @include auto-rtl(left, -23.2px);
        background-color: $ph-card;
        transform: translateY(-50%) scaleX(0.42) rotate(45deg);
        border-radius: $ph-small-radius;
        border-right: 0.6rem solid var(--bg-color);
        border-top: 0.6rem solid var(--bg-color);
      }
    }
  }
  &.sticky {
    position: sticky;
    z-index: 90;
    top: $header-height;
  }
}
.app-rtl {
  .sub-menu {
    &.horizontal-arrow {
      .list-group__item-expander {
        &:after {
          border-right: unset;
          border-top: unset;
          border-left: 0.6rem solid var(--bg-color);
          border-bottom: 0.6rem solid var(--bg-color);
        }
      }
    }
  }
}
</style>
